export const setItem = (key: string, value: string) => {
  return localStorage.setItem(key, value);
};

export const getItem = (key: string) => {
  return localStorage.getItem(key);
};

export const setCurrentLocalStorageWorkspace = (value: string) => {
  return setItem('currentWorkspace', value);
};

export const getCurrentLocalStorageWorkspace = () => {
  const workspace = getItem('currentWorkspace');
  if (workspace) {
    return parseInt(workspace, 10);
  }
  return workspace;
};
